module.exports = __webpack_public_path__ + "static/media/FtaKitWordLogo.fb961152.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/FtaKitWordLogo.png
// module id = 579
// module chunks = 0